<template>
  <section>
    <AppLoading v-if="loading" />

    <div v-else>
      <div class="grid grid-cols-12 gap-6 mt-5">
        <div class="intro-y col-span-12 lg:col-span-12">
          <div class="intro-y box">
            <div class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200">
              <h2 class="font-medium text-base mr-auto w-full">
                <template v-if="existSlug">
                  <template v-if="isShow">Detalle Actividad</template>
                  <template v-else>
                    <div class="flex justify-between">
                      <div>Editar Preguntas | {{ activity.name }}</div>
                      <div>{{ activity.type }}</div>
                    </div>
                  </template>
                </template>
                <template v-else>Crear Actividad</template>
              </h2>
            </div>

            <form class="intro-y grid grid-cols-12 gap-3 p-5" @submit.prevent="createActivity" v-if="!existSlug || isShow">
              <div class="mt-3 col-span-6 sm:col-span-6">
                <label>Nombre</label>
                <input type="text" class="input w-full border mt-2" v-model="activity.name" :disabled="checked" maxlength="60">
              </div>

              <div class="mt-3 col-span-6 sm:col-span-6">
                <label>Imagen <span class="text-blue-700">(460px x 400px, 1MB Max)</span>
                  <a v-if="activity.image != null"
                    class="text-blue-600 underline"
                    :href="activity.image"
                    target="_blank">ver actual</a>
                </label>
                <input type="file" class="hidden" id="file" @change="onFileChange" accept="image/png, image/jpeg, image/jpg, image/gif, image/svg">
                <div class="flex mt-2 my-auto w-full">
                  <input type="text"
                    class="input w-2/3 border"
                    v-model="activity.image.name"
                    required
                    disabled
                    v-if="activity.image">
                  <label for="file" class="button bg-theme-10 text-white button-sm w-1/3">
                    <i class="fa fa-plus"></i> Cargar Imagen
                  </label>
                </div>
              </div>

              <div class="mt-3 col-span-12 sm:col-span-12">
                <label>Descripcion</label>
                <textarea class="input w-full border mt-2" v-model="activity.description" :disabled="checked"></textarea>
              </div>

              <div class="mt-3 col-span-4 sm:col-span-4">
                <label>Fecha inicio</label>
                <input type="date" class="input w-full border mt-2" v-model="activity.start_date" :disabled="checked">
              </div>

              <div class="mt-3 col-span-4 sm:col-span-4">
                <label>Fecha final</label>
                <input type="date" class="input w-full border mt-2" v-model="activity.end_date" :disabled="checked">
              </div>

              <div class="mt-3 col-span-4 sm:col-span-4 md:col-span-4">
                <label>Tipo</label>
                <select class="input w-full border mt-2 flex-1" v-model="activity.type" :disabled="checked"
                  @change="changeType($event)">
                  <option seleted :value="null">Seleccione ...</option>
                  <option v-for="activityType in activityTypes"
                    :value="activityType"
                    :key="`${activityType}-activityType`">
                    {{activityType}}
                  </option>
                </select>
              </div>

              <div class="mt-3 col-span-4 sm:col-span-4 md:col-span-4" v-if="type_content">
                <label>Tipo Contenido</label>
                <select class="input w-full border mt-2 flex-1" v-model="activity.type_content" :disabled="checked"
                  >
                  <option seleted :value="null">Seleccione ...</option>
                  <option v-for="activityTypeContent in activityTypeContents"
                    :value="activityTypeContent"
                    :key="`${activityTypeContent}-activityTypeContent`">
                    {{activityTypeContent}}
                  </option>
                </select>
              </div>

              <div class="mt-3 col-span-4 sm:col-span-4">
                <label>Puntos de 90% a 100% correcto</label>
                <input type="number" class="input w-full border mt-2" v-model="activity.points_high_correct" :disabled="checked">
              </div>

              <div class="mt-3 col-span-4 sm:col-span-4" v-if="percentage_80">
                <label>Puntos de 80% a 90% correcto</label>
                <input type="number" class="input w-full border mt-2" v-model="activity.points_medium_correct" :disabled="checked">
              </div>

              <div class="mt-3 col-span-4 sm:col-span-4" v-if="percentage_70">
                <label>Puntos de 70% a 80% correcto</label>
                <input type="number" class="input w-full border mt-2" v-model="activity.points_under_correct" :disabled="checked">
              </div>

              <div class="mt-3 col-span-4 sm:col-span-4 md:col-span-4">
                <label>Estado</label>
                <select class="input w-full border mt-2 flex-1" v-model="activity.status" :disabled="checked">
                  <option :value="1">Activa</option>
                  <option :value="0">Inactiva</option>
                </select>
              </div>

              <div class="mt-3 col-span-4 sm:col-span-4">
                <label>Material de estudio <span class="text-blue-700">(PDF, 5MB Max)</span>

                  <a v-if="activity.study_information !== null"
                    class="text-blue-600 underline"
                    :href="activity.study_information"
                    target="_blank">ver actual</a>
                </label>
                <input type="file" class="hidden" id="study_information" @change="onStudyActivityFileChange">
                <div class="flex mt-2 my-auto w-full">
                  <input type="text"
                    class="input w-2/3 border"
                    v-model="activity.study_information.name"
                    required
                    disabled
                    v-if="activity.study_information">
                  <label for="study_information" class="button bg-theme-10 text-white button-sm">
                    <i class="fa fa-plus"></i> Cargar Material de estudio
                  </label>
                </div>
              </div>

              <template v-if="!existSlug">
                <div v-if="checked" class="mt-3 col-span-12">
                  <button type="button" @click="createBudget()" class="button bg-theme-1 text-white mt-auto">
                    Confirmar Actividad
                  </button>
                  <button type="button" @click="checked = false" class="button bg-theme-11 text-white mt-auto">
                    Editar Actividad
                  </button>
                </div>

                <div v-else class="mt-3 col-span-12">
                  <button type="submit" class="button bg-theme-1 text-white mt-auto">
                    Crear Actividad
                  </button>
                </div>
              </template>
            </form>

            <ActivityQuestionsComponent
              v-if="existSlug && activity.type != 'Extra'"
              :activity="activity" />
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Loading from '@/components/admin/partials/LoadingWhite'
  import ActivityQuestionsComponent from './ActivityQuestions.vue'

  export default {
    name: 'CreateActivity',
    data () {
      return {
        loading: true,
        view: {
          entity: 'activity',
          id: this.$route.params.slug
        },
        checked: false,
        existSlug: false,

        activity: this.defineActivity(),
        activityQuestions: [],
        activityTypes: [
          'Trivia',
          'Parejas',
          'Ordenar Letras',
          'Extra',	
        ],
        activityTypeContents: [
          'Url',
          'Texto',
        ],
        loadImage: false,
        isShow: false,
        type: null,
        percentage_70: false,
        percentage_80: false,
        type_content: false,
      }
    },
    computed: {
      ...mapGetters({
        //activity: 'getActivity',
      }),
    },
    async beforeMount () {
      if (this.$route.name == 'show-activity') {
        this.isShow = true
      }
      try {
        this.existSlug = this.$route.params.slug ? true : false

        if (this.existSlug) {
          this.checked = true
          await this.lookCurrentActivity()
        }

      } finally {
        this.loading = false
      }
    },
    methods: {
      defineActivity: () => ({
        name: null,
        description: null,
        image: null,
        points_high_correct: null,
        points_medium_correct: null,
        points_under_correct: null,
        status: 1,
        type: null,
        start_date: null,
        end_date: null,
        entity: 'activity',
        study_information: null,
      }),
      async lookCurrentActivity() {
        try {
          this.activity = await this.show(this.view)
        } catch (error) {
          this.$router.push('/admin/activities')
        } finally {
          this.loading = false
        }
      },
      async createActivity() {
        this.loading = true

        try {

          const formData = new FormData()

          Object.entries(this.activity)
          .forEach(([key, value]) => {
            formData.append(key, value)
          })

          await this.store(formData).then((data) => {
            console.log('then')
            const { model } = data;
            console.log(model)
            this.$router.replace(`/admin/activities/${model.slug}/questions`)
          }).catch(error => {
            var data = error.response.data
            if (data.errors) {
              var errors = data.errors

              for (var item in errors) {
                for (let i = 0; i < errors[item].length; i++) {
                  window.$toast.error(errors[item][i])
                }
              }
            }
          })
        } catch (error) {
          console.log('FAILURE!!');
          console.log({ error })
        } finally {
          this.loading = false
        }
      },
      onFileChange (e) {
        this.loadImage = true
        let files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }
        this.activity.image = e.target.files[0]
      },
      onStudyActivityFileChange (e) {
        this.loadImage = true
        let files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }
        console.log(files)
        this.activity.study_information = e.target.files[0]
      },
      changeType (e) {
        const value = e.target.value
        this.activity.type = value
        if(value != "Extra") {
          this.percentage_70 = true
          this.percentage_80 = true
          this.type_content = false
        } else {
          this.percentage_70 = false
          this.percentage_80 = false
          this.type_content =  true
        }
      },
      ...mapActions([
        'show',
        'getAll',
        'getList',
        'update',
        'store'
      ])
    },
    components: {
      ActivityQuestionsComponent,
      AppLoading: Loading
    }
  }
</script>



// WEBPACK FOOTER //
// CreateActivity.vue?85ed7732